import { Routes } from '@angular/router';
import { sessionGuard } from 'app/guards/session.guard';

export const clientsAdminRoutes: Routes = [
  {
    canActivate: [sessionGuard],
    data: { key: 'clients-admin' },
    loadComponent: () => import('./clients-admin/clients-admin.page').then((m) => m.ClientsAdminPage),
    path: '',
  },
];
